import React, { Component } from 'react';
//import FaAngleRight from 'react-icons/lib/fa/FaAngleRight';
import {Link} from "react-router-dom";
import './styles.css';

class EventListItem extends Component {
  render(){
    return (
      <Link className="event-item-container" to={`/location/${this.props.location}`}>
          <h4 className="Light">{this.props.location}</h4>
          <h4>{this.props.title}</h4>
          <div className="date">{this.props.date}</div>
          <div className="bttn-middle"><img src="/img/arrow-r.png" alt="arrow"/></div>
      </Link>
    );
  }
}

export default EventListItem;



// WEBPACK FOOTER //
// ./src/components/EventListItem/EventListItem.js